import './Footer.css';
import logo from '../assets/Silwren_white_logo.png';



export default function Footer() {
  return (
    <footer className="sil-footer">
      <div className="sil-footer-inner">
        <div className="sil-footer-brand">
          <div className="sil-footer-logo">
            <div className="sil-footer-logo-box">
              <img src={logo} alt="Silwren" />
            </div>
            {/* <h4 style={{margin:0}}>Silwren™</h4> */}
          </div>
          <p>Intelligence Woven in Silicon. Building Smart Agents, Computer Vision and Vision-driven Robotics.</p>
        </div>

        {/* <div className="sil-footer-col">
          <h5>Products</h5>
          <ul>
            <li><a href="#agents">Smart Agents</a></li>
            <li><a href="#robotics">Robotics Platform</a></li>
            <li><a href="#research">Research</a></li>
          </ul>
        </div> */}

        <div className="sil-footer-col">
          <h5>Company</h5>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/blog">Blog</a></li>
            {/* <li><a href="#careers">Careers</a></li>
            
            <li><a href="/contactUs">Contact</a></li> */}
          </ul>
        </div>

        <div className="sil-footer-col">
          <h5>Contact</h5>
          <ul>
            <li style={{color:'#CBD5E1', fontSize:'14px'}}>contact@silwren.com</li>
            <li style={{color:'#94A3B8', fontSize:'14px'}}>Pune, Maharashtra<br/>India</li>
          </ul>
        </div>
      </div>

      <div className="sil-footer-bottom">
        <div>© 2026 Silwren™. All rights reserved.</div>
        {/* <div className="sil-footer-links">
          <a href="#privacy">Privacy Policy</a>
          <a href="#terms">Terms of Service</a>
          <a href="#cookies">Cookies</a>
        </div> */}
      </div>
    </footer>
  );
}